import React from 'react';
import Table from './table/Table';
import { observer, inject } from 'mobx-react';
import { cdn } from '../helpers/cdn';

const metadata = {
    icon: cdn('icons/chatters.svg'),
    title: 'Top Chatters',
    colorPrimary: '#00bfe0',
    colorSecondary: '#f0fcff',
};

@inject('store') @observer
class ChattersTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideBots: false,
        };
        this.toggleBots = this.toggleBots.bind(this);
    }

    toggleBots () {
        this.setState({
            hideBots: !this.state.hideBots,
        });
    }

    render () {
        const {store} = this.props;
        const {hideBots} = this.state;
        const {items, status} = store.chatters;
        const data = hideBots ? items.filter(item => !blackList[item.key]) : items;

        return (
            <Table tableMetadata={metadata} status={status} toggleFunc={this.toggleBots} data={data} toggleOn={!hideBots}
                   tableType="chatters"/>
        );
    }
}

const blackList = {
    'hnlbot': true,
    'nightbot': true,
    'streamelements': true,
    'moobot': true,
    'revlobot': true,
    'wizebot': true,
    'mirrobot': true,
    'xanbot': true,
    'twitchnotify': true,
    'ausrobot': true,
    'towzeurbot': true,
    'mikuia': true,
    'vivbot': true,
    'wondertradestimer': true,
    'snusbot': true,
    'poketrivia': true,
    'priestbot': true,
    'dismantletrivia': true,
    'jibot': true,
    'swiftsbot': true,
    'waifu4u': true,
    'gather_bot': true,
    'drangrybot': true,
    'monstercat': true,
    'ttdbot': true,
    'nurserybot': true,
    'betdan': true,
    'tpp': true,
    'bot811': true,
    'economy': true,
    'talontedbot': true,
    'kikettebot': true,
    'sakatibot': true,
    'aoaagoldbot': true,
    'pokequiz': true,
    'jakesjungle': true,
    'wzbot': true,
    'cohhilitionbot': true,
    'streamlabs': true,
    'wondertradeboss': true,
    'the_kraken_bot': true,
    'ere_bot': true,
    'nookys_cookiemonster': true,
    'clumsytradetimer': true,
    'unlikelybot': true,
    'tayronbot': true,
    'zhbot': true,
    'robogrub': true,
    'loopy_the_merciful': true,
    'kfcmanagerbot': true,
    'lobotjr': true,
    'skip_wtf_bot': true,
    'onscreenbot': true,
    'sheepfarmer': true,
    'thebowlcutbot': true,
    'pear_bot': true,
    'k33nbot': true,
    'triviabotter': true,
    'wowsobot': true,
    'hotdogmeme': true,
    'ohbot': true,
    'stay_hydrated_bot': true,
    'mitsukibot': true,
    'fossabot': true,
    'elementsbot': true,
    'own3d': true,
    'restreambot': true,
    'pretzelrocks': true,
};

export default ChattersTable;



// WEBPACK FOOTER //
// ./src/app/components/ChattersTable.js